import { BaseErrorHandler } from '@app/@graphql';
import { ErrorResponse } from '@apollo/client/link/error';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';
import { marker } from '@biesbjerg/ngx-translate-extract-marker';

export class OfflineErrorHandler extends BaseErrorHandler {
  constructor(private translate: TranslateService, private toastr: NbToastrService) {
    super();
  }

  handleError({ graphQLErrors, networkError, response }: ErrorResponse) {
    if (graphQLErrors === undefined) {
      this.toastr.danger(this.translate.instant(marker('request_error_message')), this.translate.instant(marker('request_error_title')), {
        duration: this.duration,
        preventDuplicates: true
      });
    }
  }
}
